<template>
  <div class="container">
    <div
      class="navBar_topic"
      v-if="showFixed"
      :style="{
        backgroundImage: `url(${info.BackImage})`,
        opacity: `${navOpacity}`,
      }"
    >
      <div class="nt_title" style="line-height: 40px">
        {{ info.TopicName }}
      </div>
      <div>{{ info.TopicDesc }}</div>
    </div>
    <div class="top-box">
      <van-image fit="cover" :src="info.BackImage" class="topImg" />
      <div class="tb_title">{{ info.TopicName }}</div>
      <div class="tb_describe">{{ info.TopicDesc }}</div>
      <div class="tb_btm">
        <div @click.stop="toHomePage(info.MemberId)">
          <van-image
            round
            error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            :src="info.CreaterPhoto"
          />
          <div class="tb_man">
            <div>
              {{ info.CreaterNickName }}
              <div>发起人</div>
            </div>
            <div>
              已产生{{ info.CreaterPostCount }}篇内容，带来{{
                info.CreaterViews
              }}次浏览
            </div>
          </div>
        </div>
        <div class="shareTopic" @click.stop="shareHandle">
          <div class="iconfont icon-share1"></div>
          分享话题
        </div>
      </div>
    </div>

    <div class="classifyNav">
      <van-tabs
        type="line"
        v-model="active"
        title-active-color="#d62f2f"
        line-width="32px"
        line-height="5px"
        @change="typeClick"
      >
        <van-tab title="最新"></van-tab>
        <van-tab title="最热"></van-tab>
      </van-tabs>

      <!-- 查询框 -->
      <div class="query-box" v-if="searchShow">
        <span class="iconfont icon-search"></span>
        <input
          type="text"
          v-model="keyword"
          @blur="searchHandle"
          @keyup.enter="searchHandle"
        />
        <div class="clear" @click.stop="clearClick">
          <span class="iconfont icon-clear"></span>
        </div>
      </div>
      <div class="query-box stop" @click.stop="focusClick" v-else>
        <span class="iconfont icon-search"></span>
      </div>
    </div>

    <!-- 动态列表 -->
    <div v-if="delay">
      <van-list
        v-if="list != null && list.length > 0"
        v-model="loading"
        :finished="finished"
        finished-text="-The End-"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        :immediate-check="check"
        @load="getListHandle"
      >
        <dynamic-list :list="list"></dynamic-list>
      </van-list>
      <div v-else>
        <div class="noDataBox" v-if="firstOperate.total">
          <span class="iconfont icon-kong"></span>
          <div>什么也没有！</div>
        </div>
        <div class="noData" v-else>
          <img src="../../../static/images/topic/noTopic.png" />
          <div class="no_tips">该话题居然还没人说话？</div>
          <div class="createBtn" @click.stop="addChange">我先说说</div>
        </div>
      </div>
    </div>

    <div class="operate-box" @click.stop="addChange" v-if="info.IsClose != 1">
      <div class="ob_top" v-if="addState">
        <div style="margin-bottom: 6px" @click.stop="toPulishPic">
          <div class="iconfont icon-tuwen" style="color: #1987e4"></div>
          图文
        </div>
        <div @click.stop="toPulishVideo">
          <div class="iconfont icon-shipin" style="color: #fd5f11"></div>
          视频
        </div>
      </div>
      <div class="openBtn">
        <div class="iconfont icon-add"></div>
        <div v-if="!addState">
          <div class="wave_scale"></div>
          <div class="wave_scale delay"></div>
        </div>
      </div>
    </div>

    <!--分享-->
    <div class="shareLayer" v-show="showLayer" @click="showLayer = false">
      <img src="../../../static/images/index/layer.png" />
    </div>
    <!--遮罩层-->
    <van-overlay v-show="showLayer" @click="showLayer = false"></van-overlay>
  </div>
</template>
<script>
import { postTopicInfo, topicPostList } from "@/api/topic";
import {
  Col,
  Icon,
  List,
  Overlay,
  Row,
  Tab,
  Tabs,
  Toast,
  Image,
  Search,
} from "vant";
import DynamicList from "@/components/dynamicList.vue";
export default {
  name: "hotTopicDetails",
  components: {
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-list": List,
    "van-col": Col,
    "van-row": Row,
    "van-icon": Icon,
    "van-overlay": Overlay,
    "van-image": Image,
    "van-search": Search,
    DynamicList,
  },
  data() {
    return {
      check: true,
      //第一次获取数据
      firstOperate: {
        isLoaded: false,
        total: 0,
      },

      showFixed: false,
      navOpacity: 0,
      showLayer: false,

      info: "",
      active: 0, //0最新 3最热

      topicId: null, //话题id
      addState: false,

      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],

      keyword: "",
      focus: false,
      searchShow: false,

      delay: false, //延迟页面加载
    };
  },
  methods: {
    //点击查询聚焦
    focusClick() {
      this.searchShow = true;
      this.focus = true;
    },

    //清空点击
    clearClick: function () {
      this.keyword = "";
      this.list = [];
      this.pageIndex = 1;
      this.delay = true;
      this.getListHandle();
    },

    //搜索
    searchHandle() {
      this.list = [];
      this.pageIndex = 1;
      this.delay = true;
      this.getListHandle();
    },

    //跳转发布视频
    toPulishVideo() {
      this.$router.push({
        path: "/publishVideo",
        query: { first: 1, hid: this.$route.query.hid },
      });
    },

    //跳转发布图文
    toPulishPic() {
      this.$router.push({
        path: "/publishPic",
        query: { hid: this.$route.query.hid },
      });
    },

    //tab切换
    typeClick(name) {
      this.active = name;
      this.pageIndex = 1;
      this.list = [];
      this.getListHandle();
    },

    //加号按钮点击
    addChange() {
      if (this.info.IsClose == 1) {
        Toast("该话题已关闭！");
      } else {
        this.addState = !this.addState;
      }
    },

    //获取详情
    getInfo() {
      var that = this;
      var data = {
        TopicId: that.$route.query.hid,
      };
      postTopicInfo(data).then((res) => {
        this.info = res.Data;
      });
      if (that.check) {
        that.getListHandle();
      }
    },

    //获取动态列表
    getListHandle() {
      var that = this;
      var data = {
        TopicId: Number(that.$route.query.hid),
        Type: that.active,
        Page: {
          PageSize: 20,
          PageIndex: that.pageIndex,
        },
        Keyword: that.keyword,
      };
      topicPostList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
            if (!that.firstOperate.isLoaded) {
              this.firstOperate.isLoaded = true;
              this.firstOperate.total = res.Data.Total;
            }
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.delay = true;
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //分享好友
    shareHandle() {
      this.showLayer = true;
    },

    //跳转个人主页
    toHomePage(mid) {
      this.$router.push({ path: "/homePage", query: { mid: mid } });
    },

    //判断滚动条位置
    handleScroll() {
      this.addState = false;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 300) {
        this.showFixed = true;
        this.navOpacity =
          scrollTop > 600 ? 1 : ((scrollTop - 300) / 300).toFixed(2);
      } else {
        this.showFixed = false;
        this.navOpacity = 0;
      }
    },
  },

  mounted() {
    this.getInfo();
    window.addEventListener("scroll", this.handleScroll, true);
  },

  destroyed: function () {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
};
</script>
<style scoped src="../../../static/css/hotTopicDetails.css"></style>
